import Header from './components/Header';
import Hero from './components/Hero';
import FaqSection from './components/FaqSection';
import AppSection from './components/AppSection';
import CardsSection from './components/CardsSection';
import ContactSection from './components/ContactSection';
import UpdatesSection from './components/UpdatesSection';
import TopicsSection from './components/TopicsSection';
import IndexSection from './components/IndexSection';
import RankingSection from './components/RankingSection';
import AboutSection from './components/AboutSection';
import CarouselSection from './components/CarouselSection';
import CommentsSection from './components/CommentsSection';
import FeaturesSection from './components/FeaturesSection';
import MediaSection from './components/MediaSection';
import Footer from './components/Footer';

export default function Home() {
  return (
    <>
      <Header />
      <main>
        <Hero />
        <FaqSection />
        <AppSection />
        <CardsSection />
        <ContactSection />
        <UpdatesSection />
        <TopicsSection />
        <IndexSection />
        <RankingSection />
        <AboutSection />
        <CarouselSection />
        <CommentsSection />
        <FeaturesSection />
        <MediaSection />
      </main>
      <Footer />
    </>
  );
}